import { render, staticRenderFns } from "./candidate-report.vue?vue&type=template&id=5b4ffcd8&scoped=true"
import script from "./candidate-report.vue?vue&type=script&lang=js"
export * from "./candidate-report.vue?vue&type=script&lang=js"
import style0 from "./candidate-report.vue?vue&type=style&index=0&id=5b4ffcd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4ffcd8",
  null
  
)

export default component.exports